import PropTypes from 'prop-types';
import React from 'react';
import { SHOW_CARROUSEL_ARROWS } from '../../../../brands/default/features';
import ArrowButton from '../ArrowButton';

const CarouselArrow = ({
  onClickHandler,
  orientation,
  isOffset,
  extraClasses,
}) => {
  if (!SHOW_CARROUSEL_ARROWS) return null;

  return (
    <ArrowButton
      extraClasses={extraClasses}
      isOffset={isOffset}
      onClick={(event) => {
        event.stopPropagation();
        onClickHandler();
      }}
      orientation={orientation}
    />
  );
};

CarouselArrow.propTypes = {
  extraClasses: PropTypes.string,
  isOffset: PropTypes.bool,
  onClickHandler: PropTypes.func,
  orientation: PropTypes.oneOf(['prev', 'next']),
};

CarouselArrow.defaultProps = {
  extraClasses: '',
  isOffset: false,
  onClickHandler: () => false,
  orientation: 'prev',
};

export default CarouselArrow;
